// includes
require('./demo');

// add lazy-load supported
import 'vanilla-lazyload';
const images = document.querySelectorAll('img');
for (let i = 0; i < images.length; ++i) {
    let original_image_src = images[i].src;
    if (!images[i].classList.contains('lazy') && !images[i].classList.contains('no-lazy')) {
        images[i].src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        images[i].setAttribute('data-src', original_image_src);
        images[i].classList.add('lazy');
    }
}
import LazyLoad from 'vanilla-lazyload';
let myLazyLoad = new LazyLoad();

// anchor smooth scroll
document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', function (e) {
        e.preventDefault();
        let href = this.getAttribute('href');
        let elem = document.querySelector(href) || document.querySelector('a[name=' + href.substring(1, href.length) + ']');
        window.scroll({
            top: elem.offsetTop - 20, // 20 block padding
            left: 0,
            behavior: 'smooth',
        });
    });
});

// btn to top
function scrollTo(to, duration = 700) {
    const element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t + b;
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        },
        animateScroll = function () {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                element.scrollTop = to;
            }
        };
    animateScroll();
}

document.addEventListener('DOMContentLoaded', function () {
    let btn = document.querySelector('#toTop');
    if (btn) {
        window.addEventListener('scroll', function () {
            // show if > 599px
            if (pageYOffset > 100) {
                btn.classList.add('show');
                // remove
            } else {
                btn.classList.remove('show');
            }
        });

        // to top on click
        btn.onclick = function (click) {
            click.preventDefault();
            scrollTo(0, 400);
        };
    }
});

// open burger
let el = document.querySelector('.burger');
let menu = document.getElementById('header-m');
let menuLine = document.querySelector('.h-menu');
let body = document.body;

if (el) {
    el.addEventListener('click', function () {
        el.classList.toggle('active');
        menu.classList.toggle('open');
        menuLine.classList.toggle('open');
        body.classList.toggle('modal');
    });

    // закрыть меню при клике за его пределами
    document.addEventListener('click', function (event) {
        if (!menu.contains(event.target) && !el.contains(event.target)) {
            el.classList.remove('active');
            menu.classList.remove('open');
            menuLine.classList.remove('open');
            body.classList.remove('modal');
        }
    });
}

// submenus
const menuItems = document.querySelectorAll('.menu-item-has-children');
let openedMenu = null;
menuItems.forEach(function (menuItem) {
    const afterElement = menuItem.querySelector('a::after');

    menuItem.addEventListener('click', function (event) {
        const subMenu = menuItem.querySelector('.sub-menu');
        const isOpen = subMenu.classList.contains('show');

        if (openedMenu && openedMenu !== subMenu) {
            const previousOpenedMenu = openedMenu;
            openedMenu = null;
            previousOpenedMenu.classList.remove('show');
            previousOpenedMenu.parentElement.classList.remove('active');
            const previousOpenedMenuAfter = previousOpenedMenu.parentElement.querySelector('a::after');
            if (previousOpenedMenuAfter) {
                previousOpenedMenuAfter.classList.remove('opened');
            }
        }

        if (!isOpen) {
            subMenu.classList.add('show');
            menuItem.classList.add('active');
            if (afterElement) {
                afterElement.classList.add('opened');
            }
            openedMenu = subMenu;
        } else {
            subMenu.classList.remove('show');
            menuItem.classList.remove('active');
            if (afterElement) {
                afterElement.classList.remove('opened');
            }
            openedMenu = null;
        }
    });
});

/*custom toc*/
if (document.querySelectorAll('.toc-interactive li')) {
    const liElems = document.querySelectorAll('.toc-interactive li');
    liElems.forEach((elem) => {
        const childrenElems = elem.querySelectorAll('ul');
        if (childrenElems.length > 0) {
            elem.setAttribute('class', 'has-child');
            let chevronIcon = document.createElement('div');
            chevronIcon.className = 'chevron';
            elem.prepend(chevronIcon);
        }
    });

    let toggler = document.querySelectorAll('.has-child > .chevron');
    let i;
    for (i = 0; i < toggler.length; i++) {
        toggler[i].addEventListener('click', function (e) {
            this.classList.toggle('active');
            this.nextElementSibling.nextElementSibling.classList.toggle('show-submenu');
        });
    }
}

// faq
const faq_container = document.querySelector('.faq-container');
if (faq_container) {
    faq_container.addEventListener('click', function (e) {
        const items = document.querySelectorAll('.faq-container-content');
        const target = e.target;
        Array.from(items).forEach((item) => {
            if (item != target) {
                item.classList.remove('show');
            }
        });
        target.classList.toggle('show');
    });
}

// cover table
function _tableRow() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('table-row');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}

_tableRow();

// comments reply btn
document.addEventListener('click', function (event) {
    // Проверяем, что был совершен клик по кнопке "Ответить"
    if (event.target.classList.contains('comment-reply-link')) {
        // Скрываем кнопку "Ответить" после нажатия
        event.target.classList.add('hidden-reply-button');
    }

    // Проверяем, что был совершен клик по кнопке "Скасувати відповідь"
    if (event.target.id === 'cancel-comment-reply-link') {
        // Удаляем класс hidden-reply-button со всех кнопок "Ответить", чтобы они снова стали видимыми
        const replyButtons = document.querySelectorAll('.comment-reply-link');
        replyButtons.forEach(function (button) {
            button.classList.remove('hidden-reply-button');
        });
    }
});
